module.exports = __webpack_public_path__ + "e2676ec3598049c27908814fbc7b628a.svg";